import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { VerifyAccountSuccess, LoginUser } from '@webapp/store/auth/action-creators';
import { VERIFY_ACCOUNT_SUCCESS, LOGIN_USER } from '@webapp/store/auth/actions';
import AppState from '@webapp/store/state';
import { getAuthAttributes } from '@webapp/utils/auth/get-auth-attributes';

export const trackSignUpSuccess = (action$: Observable<VerifyAccountSuccess | LoginUser>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<VerifyAccountSuccess | LoginUser>(
      VERIFY_ACCOUNT_SUCCESS,
      LOGIN_USER
    ),
    filter((action: VerifyAccountSuccess | LoginUser) => action.type === VERIFY_ACCOUNT_SUCCESS || action.afterVerify),
    withLatestFrom(state$),
    map(([_, state]) => {
      if (window.analytics) {

        const source = getAuthAttributes(state.auth.user);

        window.analytics.track('Signed Up', {
          id: source?.sub,
          email: source?.email,
          phone: source?.telephone
        });
      }
    }),
    filter(() => false)
  )